import { Checkbox, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthService } from "../APIService/AuthService";
import { StyledInput } from "../components/login/StyledInput";
import { AuthTypeEnum } from "../enums";
import { useAuthContext } from "../context/authContext";
import { Button } from "../shared/button";
import { TAuth } from "../types";
import { useSnackbar } from "notistack";
import { Navigate } from "react-router-dom";

export function LogoutForm() {
  const { setIsAuth } = useAuthContext();

  useEffect(() => {
    const logout = () => {
      AuthService.logout();
      setIsAuth(false);
    };
    logout();
  }, [setIsAuth]);

  return <Navigate to="/login" />;
}

export function LoginForm(props: { type: string }) {
  const { type } = props;

  const navigate = useNavigate();
  const { state: locationState } = useLocation();

  const [agreePII, setAgreePII] = useState(false);
  const { setIsAuth, setStudentId } = useAuthContext();
  const [state, setState] = useState<TAuth>({
    email: "",
    password: "",
  });
  const [registering, setRegistering] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setRegistering(true);
    try {
      const auth: any =
        type === AuthTypeEnum.LOGIN
          ? await AuthService.loginUser(state)
          : await AuthService.register(state);
      setIsAuth(!!localStorage.getItem("auth"));
      setStudentId(auth.id);
      if (locationState) {
        const { redirectTo } = locationState as { redirectTo: Location };
        navigate(`${redirectTo.pathname}${redirectTo.search}`);
      } else {
        if (type === AuthTypeEnum.LOGIN) navigate("/");
        else navigate("/account");
      }
    } catch (e: any) {
      enqueueSnackbar(e.response.data.message || e.response.data.error, {
        variant: "error",
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
    }
  };

  useEffect(() => {
    setState({ email: "", password: "" });
  }, [type]);
  const { email, password } = state;

  return (
    <div>
      <Grid
        direction={"column"}
        container
        justifyContent={"center"}
        alignContent={"center"}
      >
        <Grid item xs={12} sm={12} md={12}>
          {type === AuthTypeEnum.LOGIN ? (
            <h3>Войти в личный кабинет</h3>
          ) : (
            <h3>Зарегистрироваться</h3>
          )}
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <Grid item xs={12} sm={12} md={12}>
            <StyledInput
              placeholder="Email"
              name="email"
              type="email"
              value={email}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <Grid item xs={12} sm={12} md={12}>
            <br />
            <StyledInput
              type="password"
              placeholder="Пароль"
              name="password"
              value={password}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={1}
          sm={1}
          md={1}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            pt: "20px",
          }}
        >
          {type === AuthTypeEnum.REGISTER ? (
            <Grid sx={{ textAlign: "center" }}>
              <Checkbox
                name="agreePII"
                checked={agreePII}
                onChange={() => setAgreePII(!agreePII)}
              />
              Ознакомлен с политикой обработки персональных данных <br />
              и даю свое согласие на их обработку
              <br />
              <br />
            </Grid>
          ) : null}

          <Button
            onClick={handleSubmit}
            type={"submit"}
            style={{ marginRight: "10px" }}
            disabled={
              (type === AuthTypeEnum.REGISTER && !agreePII) || registering
            }
          >
            {type === AuthTypeEnum.LOGIN ? "Войти" : "Зарегистрироваться"}
          </Button>

          {type === AuthTypeEnum.LOGIN ? (
            <Link to={"/forgot-password"}>
              <Button>Забыли пароль? </Button>
            </Link>
          ) : (
            <div />
          )}
        </Grid>

        {type === AuthTypeEnum.LOGIN ? (
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            sx={{ textAlign: "center", pt: "30px" }}
          >
            <Link to={"/register"}>Зарегистрироваться</Link>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </div>
  );
}
